import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TableType } from '../types/table-types.type';
import { LogType } from '../types/log-types.type';

// Interface alinhada com o backend LogSummaryDTO
export interface LogSummaryDTO {
  period: string;
  userId: number | null;
  userShortName: string | null;
  userCpf: string | null;
  table: string;            // enum: "CREDENTIAL", "PEOPLE", "ADDRESS", "DOCUMENT", "USER"
  action: string;           // enum: "ADDED", "UPDATED", "DELETED", "VIEWED", "CANCELED", "PRINTED"
  total: number;
  source: 'LEGACY' | 'NEW'; // origem dos dados
  // --- campos derivados (preenchidos pelo map abaixo) ---
  tableName?: string;
  actionName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SummaryService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Consulta resumo unificado de auditoria.
   * Combina tb_log_data (legado) + tb_audit_entry (novo).
   */
  getSummary(
    initialDate: string,
    finalDate: string,
    userId?: number,
    table?: string,
    action?: string,
    period: string = 'dia'
  ): Observable<LogSummaryDTO[]> {
    let params = new HttpParams()
      .set('initialDate', initialDate)
      .set('finalDate', finalDate)
      .set('period', period);

    if (userId) params = params.set('userId', userId.toString());
    if (table) params = params.set('table', table);
    if (action) params = params.set('action', action);

    // Endpoint unificado (tb_log_data + tb_audit_entry)
    const url = `${this.apiUrl}/sicred/api/v1/logs/summary`;
    return this.http.get<LogSummaryDTO[]>(url, { params }).pipe(
      map(data => data.map(item => ({
        ...item,
        // Resolve nomes amigáveis a partir dos enums
        tableName: TableType[item.table as keyof typeof TableType] || item.table,
        actionName: LogType[item.action as keyof typeof LogType] || item.action
      })))
    );
  }
}